export default {
  privat: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Zuhause & Grundstück',
    hero: {
      eyebrow: 'Privatkunden',
      title: 'Ihr Zuhause im Blick – passend geplant und dezent installiert',
      lead: 'Ob Einfamilienhaus, Eigentumswohnung oder Mehrfamilienhaus – wir schützen Ihre Privatsphäre und Ihr Eigentum mit maßgeschneiderten Kamerasystemen. Ohne Angstwerbung, ohne übermäßige Überwachung.',
    },
    useCases: {
      title: 'Lösungen für Ihr Zuhause',
      lead: 'Jedes Haus ist anders. Wir betrachten Ihre individuellen Zugänge, Lichtverhältnisse und Wünsche – und planen die passenden Überwachungspunkte.',
      items: {
        '0': { title: 'Haustür & Eingangsbereich', desc: 'Die Haustür ist der wichtigste Überwachungspunkt. Wir planen eine diskrete Kamera mit guter Detailauflösung – für Gesichtserkennung und Paketüberwachung.' },
        '1': { title: 'Einfahrt & Garage', desc: 'Kennzeichenerkennung, Fahrzeugüberwachung und Zugangskontrolle – mit witterungsfesten Außenkameras und Nachtsicht.' },
        '2': { title: 'Garten & Terrasse', desc: 'Überwachen Sie Gartenzugänge, Terrassen und Nebeneingänge. Wetterfeste Kameras mit Weitwinkel für den Überblick.' },
        '3': { title: 'Nebeneingänge & Kellertür', desc: 'Oft übersehen, aber ein beliebter Zugangspunkt. Zusätzliche Kameras an Nebeneingängen schließen die letzte Lücke.' },
        '4': { title: 'Mehrfamilienhäuser', desc: 'Eingangsbereich, Treppenhaus und Außenanlagen – datenschutzbewusst geplant mit Privatzonen-Maskierung und Hinweisschildern.' },
        '5': { title: 'Smartphone-Zugriff', desc: 'Live-Ansicht und Wiedergabe auf Ihrem Handy – egal ob Sie zuhause oder unterwegs sind. Wir richten alles ein.' },
      },
    },
    night: {
      eyebrow: 'Nachtsicht',
      title: 'Sicherheit, die nicht schläft',
      lead: 'Die meisten Vorfälle passen in der Dunkelheit. Mit speziellen Tag-/Nacht-Kameras behalten Sie auch bei Nacht den Überblick – in Schwarz-Weiß mit Infrarot oder sogar in Farbe.',
      items: {
        '0': { title: 'Infrarot-Nachtsicht', desc: 'Scharfe Bilder auch bei kompletter Dunkelheit – bis zu 30m Reichweite je nach Modell.' },
        '1': { title: 'Color-Night', desc: 'Farbbilder bei Nacht statt schwarz-weiß – dank hochempfindlicher Starlight-Sensoren.' },
        '2': { title: 'Intelligente Beleuchtung', desc: 'Weißlicht-LEDs bei Bewegung als Abschreckung und gleichzeitig für farbige Aufnahmen.' },
      },
    },
    privacy: {
      eyebrow: 'Datenschutz',
      title: 'Privatzonen schützen, Rechte beachten',
      lead: 'Bei der privaten Videoüberwachung ist Datenschutz besonders wichtig. Wir achten von Anfang an auf:',
      list: {
        '0': 'Keine Erfassung öffentlicher Straßen oder Nachbargrundstücke',
        '1': 'Privatzonen-Maskierung direkt in der Kamera oder am Rekorder',
        '2': 'Hinweisschilder an den Eingängen (rechtlich empfohlen)',
        '3': 'Lokale Speicherung – Ihre Daten bleiben bei Ihnen',
        '4': 'Zugriffsrechte und Benutzerverwaltung für Mehrfamilienhäuser',
      },
      note: 'Hinweis: Die rechtliche Zulässigkeit der Videoüberwachung hängt vom Einzelfall ab. Wir beraten Sie, ersetzen aber keine Rechtsberatung.',
    },
    cta: {
      title: 'Schützen Sie, was Ihnen wichtig ist',
      lead: 'Ein unverbindliches Erstgespräch zeigt Ihnen, welche Möglichkeiten es für Ihr Zuhause gibt – transparent und ohne Druck.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'KameraPlaner starten',
    },
  },
};